import { r as b, b as y, P as i, h as o, H as p, g as m } from "./index-6e735f92.js";
import { R as u } from "./register-component-083eb961-763c87e9.js";
import "react";
import "react/jsx-runtime";
import "react-dom";
const g = ':host{display:block;--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-color-blue-100:#e0e6f9;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif;--nylas-color-black:#000000;--nylas-color-grey-900:#2c2c2c;--nylas-color-grey-800:#4b4b4b;--nylas-color-grey-700:#6e6e6e;--nylas-color-grey-600:#8e8e8e;--nylas-color-grey-500:#b3b3b3;--nylas-color-grey-400:#cacaca;--nylas-color-grey-300:#e1e1e1;--nylas-color-grey-200:#eaeaea;--nylas-color-grey-100:#f5f5f5;--nylas-color-grey-50:#fbfcfe;--nylas-color-white:#ffffff;--nylas-color-red-900:#992222;--nylas-color-red-700:#cc4841;--nylas-color-red-500:#ff786a;--nylas-color-red-300:#ffa79e;--nylas-color-red-100:#ffc5bf;--nylas-color-red-50:#ffeae8;--nylas-color-blue-900:#213571;--nylas-color-blue-700:#314fa9;--nylas-color-blue-500:#4169e1;--nylas-color-blue-300:#bdccf9;--nylas-color-blue-100:#e0e6f9;--nylas-color-blue-50:#f6f8fd;--nylas-color-yellow-900:#7c6506;--nylas-color-yellow-700:#c29f09;--nylas-color-yellow-500:#f7c90b;--nylas-color-yellow-300:#f9de70;--nylas-color-yellow-100:#fceba9;--nylas-color-yellow-50:#fdf4ce;--nylas-color-green-900:#0e6b60;--nylas-color-green-700:#16a392;--nylas-color-green-500:#17c3b2;--nylas-color-green-300:#74dbd1;--nylas-color-green-100:#a2e7e0;--nylas-color-green-50:#d1f3f0;--nylas-color-purple-900:#643554;--nylas-color-purple-700:#954f7d;--nylas-color-purple-500:#c769a7;--nylas-color-purple-300:#dda5ca;--nylas-color-purple-100:#e0bdd6;--nylas-color-purple-50:#e9dde5;--nylas-color-sky-900:#20698f;--nylas-color-sky-700:#2b8fc2;--nylas-color-sky-500:#6dceff;--nylas-color-sky-300:#8fdaff;--nylas-color-sky-100:#b8e7ff;--nylas-color-sky-50:#d9f2ff}.nylas-form-card{width:100%;border-radius:8px;border:1px solid var(--nylas-base-200)}.nylas-form-card__header{padding:1rem;border-bottom:1px solid var(--nylas-base-200)}', h = g;
var k = function(e, a, r, s) {
  var n = arguments.length, l = n < 3 ? a : s === null ? s = Object.getOwnPropertyDescriptor(a, r) : s, c;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    l = Reflect.decorate(e, a, r, s);
  else
    for (var t = e.length - 1; t >= 0; t--)
      (c = e[t]) && (l = (n < 3 ? c(l) : n > 3 ? c(a, r, l) : c(a, r)) || l);
  return n > 3 && l && Object.defineProperty(a, r, l), l;
}, f = function(e, a) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, a);
};
const d = class {
  constructor(e) {
    b(this, e), e.$hostElement$["s-ei"] ? this.internals = e.$hostElement$["s-ei"] : (this.internals = e.$hostElement$.attachInternals(), e.$hostElement$["s-ei"] = this.internals);
  }
  connectedCallback() {
    y("nylas-event-card", "connectedCallback");
  }
  componentWillLoad() {
    y("nylas-event-card", "componentWillLoad");
  }
  componentDidLoad() {
    y("nylas-event-card", "componentDidLoad");
  }
  disconnectedCallback() {
    y("nylas-event-card", "disconnectedCallback"), i(["header-title", "header-subtitle", "content"], this.host);
  }
  render() {
    return o(p, { key: "31393b433166bf3ff3982b62e229e9ec7ad23db7" }, o("div", { key: "79d7b1f0fb6455a06c9c2e4a1189737fbd6bcca2", class: "nylas-form-card", part: "nfc" }, o("div", { key: "c1bd78a856d6c5cca85cf8a8bf7739c1b5c3b229", class: "nylas-form-card__header", part: "nfc__header" }, o("slot", { key: "6a721147b4a50153efdee48421a57f391b86c3f5", name: "header-title" }), o("slot", { key: "6d4a96a0ca1770631da061447d78c4edaff07196", name: "header-subtitle" })), o("div", { key: "48ddebeea82502cc9a4ca5e5f3a8530ceeafca45", class: "nylas-form-card__content" }, o("slot", { key: "8cafec69611eef2be174b7a998bec6082037f42d", name: "content" }))));
  }
  static get formAssociated() {
    return !0;
  }
  get host() {
    return m(this);
  }
};
k([
  u({
    name: "nylas-form-card",
    eventToProps: {},
    fireRegisterEvent: !0
  }),
  f("design:type", Function),
  f("design:paramtypes", []),
  f("design:returntype", void 0)
], d.prototype, "render", null);
d.style = h;
export {
  d as nylas_form_card
};
